export default {
  // Adult social care
  1: {
    text: 'Care services at breaking point. Social care cuts put NHS under pressure. Families to pay more for care. Social care cuts piles pressure on GP services. Care cuts place funding crisis on families',
    id: 1,
  },
  2: {
    text: 'Council faces legal challenge over care cuts. Care cuts put hospitals under pressure. Protestors hit out at council care cuts. Older People hit by care crisis Longer waiting times for care. Social services abandoned my mum - claim',
    id: 2,
  },
  3: {
    text: 'Social care in crisis. Care cuts cause rise in hospital admissions. Families in crisis as care breaks down. Lives put at risk in care crisis. Old folk left to die at home in care crisis',
    id: 3,
  },
  // Children's social care
  4: {
    text: 'Children\'s Care in crisis. Kids in care placed outside of city. Shortage of placements for children at risk',
    id: 4,
  },
  5: {
    text: 'Children in need of council care on the rise. Overloaded social workers at risk of burnout. Overworked social workers failed to keep up with home visits putting children at risk. Increasing number of kids placed in dangerous unregulated homes. Children in care placed miles from home. Children in need abandoned by care crisis.',
    id: 5,
  },
  6: {
    text: 'Council cuts put abused kids at risk – claim. Care cuts could be ‘unlawful’. Reports of child abuse rocket amid cuts in care. People left to die. Needy kids abandoned by social worker - claim.',
    id: 6,
  },
  // Refuse, waste collection and disposal
  7: {
    text: 'Fortnightly bin collections at risk. Residents face rises in garden waste fees. Bulky waste and trade waste fees to increase.',
    id: 7,
  },
  8: {
    text: 'Jobs at risk in bin collection cutbacks. Bin collection to move to three-weekly. Fly-tipping incidents on the rise. Household Waste Recycling Centre at risk of closure. Protest over threat of three-weekly bin collections. Unions threaten strikes over council job cuts.',
    id: 8,
  },
  9: {
    text: 'Residents fury at monthly bin collections. Council waste tips could face closure. Council axes bulky waste service. Household Waste Recycling Centres to close Garden waste collection under threat after price hike sparks drop in demand.',
    id: 9,
  },
  // Early years and education
  10: {
    text: 'Childcare cuts piles pressure on social care. School admissions chaos in city. SEN transport at risk. Early years childcare cuts damages children - claim. Council cuts childcare provision as Government introduce expansion scheme. Parents left without the support they need to train and return to work. Children not ready for school due to care cuts - claim.',
    id: 10,
  },
  11: {
    text: "Support starting to be withdrawn for troubled families. 'Abandoned' families sue council over lack of support. Council at risk of failing to meet statory duties Protest over cuts to SEND travel. Cuts in early years support leaves children not ready for school - claims headteacher. Council faces legal challenge over SEND cuts.",
    id: 11,
  },
  12: {
    text: "Anger as council cuts back family support. Newcastle families hit 'crisis point'. Council condemned over school transport failure. Council facing legal action over care failures. Council cuts will damage children’s education - claim. Council axes family support services.",
    id: 12,
  },
  // Culture, Leisure and Libraries'
  13: {
    text: 'Library to close early. Libraries to face partial closures. Council to cut funding for museums. Council cuts place gallery and museum in financial crisis.',
    id: 13,
  },
  14: {
    text: 'Libraries under threat over closure. Council pulls the plug on art project. Wait times up at council contact centre. Museums and galleries face closure after council grant cut. Cuts leave library staff stressed and angry - claim. Council call centre wait times longest ever.',
    id: 14,
  },
  15: {
    text: 'All libraries to shut except city library. Discovery Museum facing closure. 10,000 sign petition to save museum from closure. Thousands sign petition to save gallery from closure',
    id: 15,
  },
  // Maintaining highways
  16: {
    text: 'Cutbacks put homes at risk of flooding. Council misses target for filling potholes. Pothole claims against council soar. Motorists hit by gritting misery.',
    id: 16,
  },
  17: {
    text: 'Outrage from women\'s groups as council considers dimming street lights. Bridge safety works at risk in cutbacks. Homes at risk of flooding from blocked gullies. Newcastle\'s roads in shocking state claim drivers. Flooded residents blame council for wrecked homes.',
    id: 17,
  },
  // Maintaining neighbourhoods
  18: {
    text: 'Refuse cuts spark dirty city row. Row in cuts to grass cutting. Fly-tipping reports on the rise. Complaints about dirty city soar.',
    id: 18,
  },
  19: {
    text: 'Back lanes hit by street cleaning cuts. Street cleaning cuts spark rise in rat reports. Council at risk of legal challenge in cuts to public health. Council cut back on grass cutting. Increase in fly-tipping blamed on council cutbacks. Newcastle branded shabby and dirty by tourists.',
    id: 19,
  },
  20: {
    text: 'Council cutbacks in grass cutting. Traders hit out at dirty city. Residents complain about dirty city. Arson attack at abandoned council depot. City rat explosion blamed on cleansing cutbacks. Residents boycott council tax in dirty city row.',
    id: 20,
  },
  // Planning and development
  21: {
    text: 'Developers hit out at planning delays. Backlog in planning applications hit a new high. Business leaders hit out at lack of development. Council criticised for delays in processing applications.',
    id: 21,
  },
  22: {
    text: 'Slump in new homes hit city. House builders attack council for lack of ambition. Collapse in commercial development hits jobs. New developments grinds to a halt. Newcastle branded UK\'s most unfriendly city - developer. New start-up homes in city hit all-time low. Planning failures cause rise in slum landlords - claim.',
    id: 22,
  },
  // Business and economic development
  23: {
    text: 'New development slows in city. Cuts to economic development will hit investment and jobs. Council misses out on government cash. Businesses miss out on vital grants due to council failure.',
    id: 23,
  },
  24: {
    text: 'Cuts to economic development hits jobs. City hit by shortage in office space. Small businesses attack council over lack of support. Big investors snub Newcastle as more move to Sunderland. Newcastle suffers slump in foreign investment.',
    id: 24,
  },
  // Enforcement and Regulation
  25: {
    text: 'Cuts in food inspections put public at risk. Illegal booze and tabs on the rise. Licensing cuts leads to rise in rogue landlords. Increase in unsafe goods on sale such as dangerous electrical items and toys. Unable to respond to complaints about housing disrepair.',
    id: 25,
  },
  26: {
    text: 'Cuts to food safety leads to rise in infection and allergen deaths. Fly-tipping blights city. Rise in Anti Social Behaviour in the city. Food poisoning outbreak blamed on cuts to enforcement. Licensing cuts sparks rise in dodgy traders. Cuts in Health and Safety sparks rise in workplace accidents. Increase in the number of houses affected by serious disrepair such as damp and mould Newcastle becomes UK\'s illegal vape capital. Council blamed for street food poisoning outbreak - report finds.',
    id: 26,
  },
  // Enabling and business functions
  27: {
    text: 'Council website crashes causing online chaos. Council failing to communicate clearly with residents - report.',
    id: 27,
  },
  28: {
    text: 'Council hit by fall in income. Council tax debt rises amid collection failures. Failure to process benefits hits poorest. Suppliers criticise council for payment delays.',
    id: 28,
  },
  29: {
    text: 'Council faces inquiry over polling day chaos. Computer chaos causes collapse in council services. Children go hungry in school meals failure. Cuts in CCTV could spark rise in disorder. City’s bereavement service slammed as inadequate. Children go hungry as school meals service collapses. Council response to major incident branded shambolic.',
    id: 29,
  }
}


// WEBPACK FOOTER //
// ./src/dictionary/news.js